export const LISTING = "BANK_BALANCE_ADJUSTMENT_LISTING";
export const DROPDOWN = "BANK_BALANCE_ADJUSTMENT_DROPDOWN";
// export const DETAILS = "BANK_BALANCE_ADJUSTMENT_DETAILS";
export const BALANCE = "BANK_BALANCE_ADJUSTMENT_BALANCE";
export const STORE_TRANSFER = "BANK_BALANCE_ADJUSTMENT_STORE_TRANSFER";
export const STORE_CASH = "BANK_BALANCE_ADJUSTMENT_STORE_CASH";
